// PrivateRoute.js
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "./authSlice";
import { userRoles } from "../../enums/userRoles";

const PrivateRoute = () => {
  const user = useSelector(selectCurrentUser);
  const location = useLocation();

  return user && user.roles.includes(userRoles.ADMIN) ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default PrivateRoute;
